<template>
  <main class="dashboard reviews">
    <ReviewHead></ReviewHead>

    <form v-if="current === 'date'" style="gap: 10px" @submit.prevent="saveSettings">
      <div class="border">
        <h5>Информация о компании</h5>

        <input type="text" class="form-control" placeholder="Название компании">
      </div>
      <div class="border">
        <h5>Загрузка ссыллок</h5>

        <small>Введите ссылки или загрузите файл</small>
        <div class="form-item">
          <label for="">Выберите группу</label>
          <template v-if="!create_group">
            <div class="d-flex">
              <select name="" id="" class="form-control" v-model="load.group">
                <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
              </select>
              <button class="btn btn-outline-success btn-sm" @click="create_group = {name: ''}">Добавить</button>
            </div>
          </template>
          <template v-else>
            <div class="d-flex">
              <input class="form-control" placeholder="Название группы" v-model="create_group.name">
              <button class="btn btn-sm btn-success" @click="createGroup">Сохранить</button>
              <button class="btn btn-sm btn-danger" @click="create_group=null">X</button>
            </div>
          </template>
        </div>
        <div class="form-item">
          <label for="">Введите ссылки<sup>*</sup> <sub>(каждая ссылка с новой строки)</sub></label>
          <textarea v-model="load.text" name="" id="" cols="30" rows="30" style="height: 150px"
                    class="form-control"></textarea>
        </div>
        <div class="form-item">
          <label for="">Или загрузите файл<sup>*</sup> </label>
          <input type="file" ref="load_link" class="form-control"
                 accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
        </div>

      </div>
      <div class="border">
        <h5>Теги </h5>
        <template v-for="category in tags">
          <div class="card-header bg-secondary">
            {{ category.name }}
          </div>
          <ul class="list-group list-group-flush">
            <li v-for="tag in category.tags" class="list-group-item">
              <span class="badge text-bg-secondary">{{ tag.name }}</span> - <i>{{ tag.comment }}</i>
            </li>
          </ul>
        </template>
      </div>
      <div class="border">
        <h5>Категории </h5>
      </div>
      <div class="border">
        <h5>Настройка парcера </h5>

        <div class="settings" v-if="settings">
          <div>
            <label class="form-label">По количеству отзывов</label>
            <input type="number" v-model="settings.review_count" class="form-control">
          </div>
          <div>
            <label class="form-label">По датам</label>
            <date-picker v-model="settings.review_date_start" style="width: 250px"
                         locale="ru"
                         :clearable="false"
                         format="dd.MM.yyyy"
                         model-type="yyyy-MM-dd"
                         auto-apply
                         :enable-time-picker="false"></date-picker>
          </div>
          <div class="mt-2">
            <label for="name" class="form-label mt-3">График запуска парсера</label>
            <MultiSelect v-if="weekdays.length"
                         v-model="settings.restart_weekday"
                         :options="weekdays"
                         :only_value="true"
                         :multi="true"
            >
            </MultiSelect>
          </div>
          <div class="mt-2">
            <label for="name" class="form-label mt-3">Время запуска парсера</label>

            <date-picker v-model="settings.restart_time" style="width: 250px"
                         locale="ru"
                         :clearable="false"
                         format="HH:mm:ss"
                         model-type="HH:mm:ss"
                         auto-apply
                         time-picker
                         :enable-time-picker="true"></date-picker>
          </div>
          <div class="mt-2">
            <label for="name" class="form-label mt-3">Количество дней парсинга</label>
            <input type="number" class="form-control" v-model="settings.restart_day_back">

            <div class="help-text">
              Дни назад для парсинга
            </div>
          </div>
        </div>
      </div>


      <button type="submit" class="btn btn-success">Сохранить</button>
    </form>


  </main>
</template>

<script>
import dataMixin from '../mixins.js';
import {DictionaryApi} from '@/api/dictionary'
import moment from "moment";
import ReviewHead from "@/views/dictionary/review/ReviewHead.vue";

export default {
  name: 'ReviewSettings',
  components: {ReviewHead},
  data() {
    return {
      name: 'reviews_monitor',
      current: "date",
      pages: {date: "Настройка глубины парсинга", tag: "Теги"},
      settings: null,
      tags: [],
      groups: [],
      create_group: null,
      load: {},
    }
  },
  computed: {
    weekdays() {
      return Array.apply(null, Array(7)).map(function (_, i) {
        return {'name': moment(i, 'e').startOf('week').isoWeekday(i + 1).format('dddd'), 'id': i};
      })
    }
  },
  watch: {},
  mounted() {
    DictionaryApi.get_list('reviews_tags', 1, 200).then(response => this.tags = response.results)
    DictionaryApi.get_review_settings(this.name).then(response => this.settings = response)
  },
  methods: {
    saveSettings() {
      const $this = this;
      DictionaryApi.save_review_settings(this.name, this.settings).then(() => {
        $this.$notify({
          type: "success",
          text: 'Настройки сохранены'
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
form {
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: baseline;

  .border {
    width: 100%;
    padding: 0 10px 10px;
    border: 1px dashed #000 !important;
    background: #fff;

    h5 {
      background: rgba(196, 199, 207, 1);
      padding: 10px;
      margin: 0 -10px 12px;
      font-size: 16px;
      font-weight: bold;
    }
  }

  button {
    margin-top: auto;
  }
}

</style>


